import { Component, Vue, Prop } from 'vue-property-decorator';
import confetti from 'canvas-confetti';
// You can declare a mixin as the same style as components.
@Component
export default class Confetti extends Vue {
  @Prop({ type: Number, default: 15 * 1000 })
  duration!: number;

  animationEnd = 0;
  defaults = { startVelocity: 30, spread: 360, ticks: 60, zIndex: 205 };
  interval!: NodeJS.Timeout;

  randomInRange(min: number, max: number) {
    return Math.random() * (max - min) + min;
  }

  triggerConfetti() {
    this.animationEnd = Date.now() + this.duration;
    this.interval = setInterval(() => {
      const timeLeft = this.animationEnd - Date.now();

      if (timeLeft <= 0) {
        return clearInterval(this.interval);
      }

      const particleCount = 50 * (timeLeft / this.duration);
      // since particles fall down, start a bit higher than random
      confetti({
        ...this.defaults,
        particleCount,
        origin: { x: this.randomInRange(0.1, 0.3), y: Math.random() - 0.2 },
      });
      confetti({
        ...this.defaults,
        particleCount,
        origin: { x: this.randomInRange(0.7, 0.9), y: Math.random() - 0.2 },
      });
    }, 250);
    setTimeout(() => {
      const canvas = document.querySelector('canvas');
      if (canvas) {
        canvas.style.zIndex = '205';
      }
    }, 251);
  }

  clearInterval() {
    clearInterval(this.interval);
  }

  destroyed() {
    this.clearInterval();
  }
}
